module.exports = __webpack_public_path__ + "img/img_live cell.0bae8891.png";